import React from "react";
import images from "../../images";
import { useTranslation } from "react-i18next";
import NewHeader from "../Home/NewHeader";

const UnderReview = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="sticky top-0 left-0 w-full bg-white z-50">
        <NewHeader className="w-full" />
      </div>
      <div className="flex flex-col justify-center items-center text-center px-4 mt-4 gap-6 w-full">
        <div className="flex justify-center items-center">
          <img
            src={images.ReviewReceiptImage}
            alt="No quests available"
            className="w-[170px]"
          />
        </div>
        <div className="flex flex-col justify-center font-medium text-2xl w-full text-center text-[#253FF6]">
          <p>{t("home.wereSorry")}</p>
        </div>
        <div className="text-[#333333] text-lg">
          <p>{t("home.yourAccountUnderReview")}</p>
        </div>
      </div>
    </>
  );
};

export default UnderReview;
